import React, { createContext, useEffect, useReducer, useState } from 'react'
import { reducer, defaultState } from '../Home/components/HomeSearchPage/reducer'
import { RouteProps } from 'react-router'
import SearchInput from './components/SearchInput/SearchInput'
import LiveRoom from './components/LiveRoom/LiveRoom'
import { HttpServer } from '../../services/server'
import { SEARCH_TYPE, ILiveRoomItem, ILectureItem, IChannelItem } from '../../services/Modules/searchServer'
import Channel from './components/Channel/Channel'
import Lecture from './components/Lecture/Lecture'
import * as Styles from './SearchResult.style'

import { Link } from 'react-router-dom'
import Loading from '@/components/Loading/Loading'
import { getLocationParamValue } from '../../utils/tools'
const EMPTY_PLACEHOLDER = 'https://static-1253442168.image.myqcloud.com/picture/12209467_e13e128f6c6ed1040a3f4f907d849431.jpg'

declare const Session: any
export const Context = createContext(null)
export default function SearchResult(props: RouteProps) {
    const [state, dispatch] = useReducer(reducer, defaultState)
    let keyword = getLocationParamValue('keyword')
    try {
        // 有可能会 decodeURIComponent 失败
        keyword = decodeURIComponent(getLocationParamValue('keyword') || '')
    } catch (error) {
        keyword = getLocationParamValue('keyword') || ''
    }
    const [liveRoomList, setLiveRoomList] = useState<ILiveRoomItem[]>([])
    const [channelList, setChannelList] = useState<IChannelItem[]>([])
    const [lectureList, setLectureList] = useState<ILectureItem[]>([])
    const [ isInited, setIsInited ] = useState(false)

    useEffect(() => {
        if (Session.weixinApi) {
            Session.weixinApi.initJSSDK()

            const shareData = {
                link: window.location.origin + window.location.pathname + window.location.search
            }

            const timeShareData = {
                ...shareData,
                link: `https://share.lizhiweike.com${window.location.pathname}${window.location.search}`
            }

            Session.weixinApi.wxShare([shareData, timeShareData])
        }
    }, [])

    useEffect(() => {
        onSearch(keyword)
    }, [])

    async function onSearch(word: string) {
        if (!word) {
            return
        }
        setIsInited(false)
        const [ liveRoomData, channeData, lectureData ] = await Promise.all(
            [
                HttpServer.getSearch<ILiveRoomItem>({ keyword: word, type: SEARCH_TYPE.LIVE_ROOM}),
                HttpServer.getSearch<IChannelItem>({ keyword: word, type: SEARCH_TYPE.CHANNEL}),
                HttpServer.getSearch<ILectureItem>({ keyword: word, type: SEARCH_TYPE.LECTURE })
            ]
        )
        setLiveRoomList(liveRoomData.data.data.records)
        setChannelList(channeData.data.data.records)
        setLectureList(lectureData.data.data.records)
        setIsInited(true)
    }
    const noSearchResult = !liveRoomList.length && !channelList.length && !lectureList.length

    return (
        <Context.Provider value={{state, dispatch}}>
            <div style={{ minHeight: '100vh', background: '#F8F8F8'}}>
                <SearchInput onSearch={onSearch} keyword={keyword} />
                {
                    isInited ?

                    <>
                        {liveRoomList.length > 0 && <LiveRoom  data={liveRoomList} keyword={keyword} />}
                        {channelList.length > 0 && <Channel data={channelList} keyword={keyword} />}
                        {lectureList.length > 0 && <Lecture data={lectureList} keyword={keyword}/>}
                        {noSearchResult && (
                            <div className={Styles.empty}>
                                <div className={Styles.wrap}>
                                    <img className={Styles.pic} src={EMPTY_PLACEHOLDER} />
                                    <p className={Styles.tip}>发现更多好课</p>
                                    <Link to={'/'}><button className={Styles.button}>返回首页</button></Link>
                                </div>
                            </div>
                        )}
                    </>
                    : <Loading />
                }
            </div>
        </Context.Provider>
    )
}



// WEBPACK FOOTER //
// ./src/views/SearchResult/SearchResult.tsx